import { callEdge } from "@/lib/edgeClient"
import type { ActivityItem } from "@/components/admin/primitives/ActivityList"

export interface RecentActivityResponse {
  items: ActivityItem[]
  total: number
}

export async function getRecentActivity(limit: number = 20): Promise<RecentActivityResponse> {
  try {
    const url = `admin-activity-recent?limit=${limit}`
    const data = await callEdge(url, {
      method: "GET",
      authRequired: true,
    })
    return data as RecentActivityResponse
  } catch (error) {
    // Edge Function not deployed - fail silently for UI to handle
    console.warn("[getRecentActivity] Edge Function not available:", error instanceof Error ? error.message : error)
    throw error
  }
}

